import { Form, Input, Select, message } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useEffect, useMemo, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import {
    setFilter,
    testRunState,
} from '../../../../../redux/testRun/testRunList.slice'
import {
    createFetchEpics,
    createFetchSprints,
    fetchTags,
    useAsyncSelect,
} from '../../../../../utils/asyncSelectHelpers'
import { isValidArray, isValidObject } from '../../../../../utils/helpers'
import { resolveTestRunProjectId } from '../../../../shared/TestRunTabs'
import AsyncTagField from '../../../../shared/AsyncTagField'
import styles from '../../../../../testrun.module.css'

const STATUS_OPTIONS = ['Pending', 'Pass', 'Fail', 'Retest']

//======================================================================================================

function FilterForm(props) {
    const {
        stateTestRun = {},
        setStateTestRun = () => {},
        handleTestCaseList = () => {},
        handleClose = () => {},
        projectId: projectIdProp,
    } = props

    const [form] = Form.useForm()
    const dispatch = useDispatch()

    const { filter, defaultFilter } = useSelector(testRunState)

    const [submitType, setSubmitType] = useState('close')

    const [saveLoading, setSaveLoading] = useState({
        saveAndNext: false,
        saveAndClose: false,
    })

    // hook up 3 async selects
    const projectId = resolveTestRunProjectId(projectIdProp)
    const fetchEpicsForProject = useMemo(
        () => createFetchEpics(projectId),
        [projectId]
    )
    const fetchSprintsForProject = useMemo(
        () => createFetchSprints(projectId),
        [projectId]
    )
    const epicSelect = useAsyncSelect(fetchEpicsForProject)
    const sprintSelect = useAsyncSelect(fetchSprintsForProject)
    const tagSelect = useAsyncSelect(fetchTags)

    const handleSubmit = async (values) => {
        setSaveLoading({
            saveAndClose: submitType === 'close',
            saveAndNext: submitType === 'next',
        })

        const selectedEpic = epicSelect?.options?.filter((item) =>
            values?.epic?.includes(item?.value)
        )
        const selectedSprint = sprintSelect?.options?.find(
            (item) => item?.value === (values?.sprint?.value || values?.sprint)
        )

        dispatch(
            setFilter({
                epic: isValidObject(selectedEpic) ? selectedEpic : '',
                sprint: isValidObject(selectedSprint) ? selectedSprint : '',
                tags: isValidArray(values?.tags) ? values?.tags : [],
                status: values?.status?.value || values?.status,
            })
        )

        setTimeout(() => {
            setStateTestRun({
                ...stateTestRun,
                filterDrawer: false,
            })
            setSaveLoading({
                saveAndClose: false,
                saveAndNext: false,
            })
        }, 500)
    }

    const handleClear = () => {
        form.setFieldsValue({
            status: null,
            sprint: null,
            tags: [],
        })
        dispatch(setFilter(defaultFilter))
        // setStateTestRun({
        //     ...stateTestRun,
        //     filterDrawer: false,
        // })
    }

    useEffect(() => {
        form.setFieldsValue({
            // epic: filter?.epic || [],
            sprint: filter?.sprint || null,
            tags: filter?.tags || [],
            status: filter?.status || null,
        })
    }, [stateTestRun, filter])

    const getOptionsForMulti = (option) => {
        if (isValidArray(option)) {
            const finalData = option?.map((item) => {
                return {
                    label: item?.name || '',
                    value: item?._id || '',
                }
            })
            return finalData
        }
        return []
    }

    return (
        <div className={styles.formPanel}>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                    sprint: filter?.sprint ? filter?.sprint : null,
                    epic: filter?.epic || [],
                    tags: filter?.tags || [],
                    status: filter?.status || null,
                }}
            >
                <Form.Item
                    label="Status"
                    name="status"
                    placeholder="Please select status"
                    rules={[
                        {
                            required: false,
                            message: 'Please select a Status',
                        },
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <Select
                        allowClear
                        placeholder="Select Status"
                        options={STATUS_OPTIONS.map((s) => ({
                            value: s,
                            label: s,
                        }))}
                    />
                </Form.Item>
                {/* EPIC */}
                {/* <Form.Item
                            label="Epic"
                            name="epic"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please select an Epic',
                                },
                            ]}
                            style={{ marginBottom: 16 }}
                        >
                            <Select
                                className="test-rail-select"
                                mode="multiple"
                                allowClear
                                showSearch
                                placeholder="Search & select Epic"
                                filterOption={false}
                                onSearch={epicSelect.onSearch}
                                // onDropdownVisibleChange={
                                //     epicSelect.onDropdownVisibleChange
                                // }
                                onOpenChange={
                                    epicSelect.onDropdownVisibleChange
                                }
                                defaultValue={
                                    isEdit
                                        ? getOptionsForMulti(
                                              isValidArray(
                                                  testCaseDetailData?.epic
                                              )
                                                  ? testCaseDetailData?.epic
                                                  : []
                                          )
                                        : []
                                }
                                onChange={(epicIds) => {
                                    form.setFieldValue('epic', epicIds)
                                }}
                                onPopupScroll={epicSelect.onPopupScroll}
                                options={epicSelect.options}
                                loading={epicSelect.loading}
                                notFoundContent={epicSelect.notFoundContent}
                                optionLabelProp="label"
                            />
                        </Form.Item> */}

                {/* SPRINT */}
                <Form.Item
                    label="Sprint"
                    name="sprint"
                    rules={[
                        {
                            required: false,
                            message: 'Please select a Sprint',
                        },
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <Select
                        className="reports_project_selecter"
                        allowClear
                        showSearch
                        placeholder="Search & select Sprint"
                        filterOption={false}
                        suffixIcon={
                            <DownOutlined
                                style={{ fontSize: 11, color: '#64748b' }}
                            />
                        }
                        onSearch={sprintSelect.onSearch}
                        onOpenChange={sprintSelect.onDropdownVisibleChange}
                        onPopupScroll={sprintSelect.onPopupScroll}
                        options={sprintSelect.options}
                        loading={sprintSelect.loading}
                        notFoundContent={sprintSelect.notFoundContent}
                        optionLabelProp="label"
                    />
                </Form.Item>

                {/* <Form.Item
                            label="Tags"
                            name="tags"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please select at least one Tag',
                                },
                            ]}
                            style={{ marginBottom: 16 }}
                        >
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    placeholder="Search & select Tags"
                                    filterOption={false}
                                    onSearch={tagSelect.onSearch}
                                    onOpenChange={
                                        tagSelect.onDropdownVisibleChange
                                    }
                                    // fieldNames={{ label: 'name', value: '_id' }}
                                    defaultValue={
                                        isEdit
                                            ? getOptionsForMulti(
                                                  isValidArray(
                                                      testCaseDetailData?.tags
                                                  )
                                                      ? testCaseDetailData?.tags
                                                      : []
                                              )
                                            : []
                                    }
                                    onChange={(tagIds) => {
                                        form.setFieldValue('tags', tagIds)
                                    }}
                                    // value={form.getFieldValue('tags')}
                                    onPopupScroll={tagSelect.onPopupScroll}
                                    options={tagSelect.options}
                                    loading={tagSelect.loading}
                                    notFoundContent={tagSelect.notFoundContent}
                                    optionLabelProp="label"
                                />
                                
                            </div>
                        </Form.Item> */}

                <AsyncTagField
                    form={form}
                    creatable={false}
                    closeOnSelect={false}
                    rules={[
                        {
                            required: false,
                            message: 'Please choose at least one item',
                        },
                    ]}
                />

                {/* Sticky actions */}
                <div className={styles.formActions}>
                    <button
                        type="submit"
                        className={`${styles.submitButton} ${
                            saveLoading?.saveAndClose
                                ? styles.submitButtonDisabled
                                : ''
                        }`}
                        disabled={saveLoading?.saveAndClose}
                        onClick={() => setSubmitType('close')}
                    >
                        {saveLoading?.saveAndClose ? 'Saving...' : 'Save'}
                    </button>
                    <button
                        type="button"
                        className={styles.cancelButton}
                        onClick={handleClear}
                    >
                        Clear
                    </button>
                    <button
                        type="button"
                        className={styles.cancelButton}
                        onClick={handleClose}
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        </div>
    )
}

export default FilterForm
